export function createListWithAds(events, adPositions) {
	if (!adPositions || !adPositions.length) {
		events.map((event) => {
			return {
				isAd: false,
				event: event,
			};
		});
	}

	const eventsWithAd = events.map((event) => {
		return {
			isAd: false,
			event: event,
		};
	});

	adPositions.forEach((adPosition) => {
		eventsWithAd.splice(adPosition, 0, {
			isAd: true,
		});
	});

	return eventsWithAd;
}
